import { render, staticRenderFns } from "./PhoneBlock.vue?vue&type=template&id=34d86c92&"
import script from "./PhoneBlock.vue?vue&type=script&lang=js&"
export * from "./PhoneBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports